export const SELLER_API_SCOPE = { params: { scope: 'seller' } } as const;

export const SELLER_CONVERSATION_PARAMS = { scope: 'seller' };
